<select [formControl]="selectControl" [id]="id" [class]="classes" (keyup)="handleDeletePress($event)" [attr.disabled]="disabled || isDisabled ? true : null">
  @if (placeholderMsg) {
    <option [ngValue]="null" hidden disabled class="sh-select__placeholder">{{ placeholderMsg }}</option>
  }
  @if (showEmptyOption) {
    <option [ngValue]="null">{{ emptyOptionLabel }}</option>
  }
  @if (extraOption) {
    <option value="{{ extraOption?.value }}" disabled>{{ extraOption?.label }}</option>
  }
  @for (option of options; track option) {
    <!-- `|| ''`: the DOM title property stringifies null/undefined to the literal text
    "null"/"undefined" instead of clearing itself, so an option without a disabledInfoMsg would
    otherwise show that as its tooltip. -->
    <option value="{{ option.value }}" [attr.disabled]="disabled || isDisabled || option.disabled ? true : null" [title]="option.disabledInfoMsg || ''">{{ option.label }}</option>
  }
</select>
